import BoxContent from "@src/component/Desktop/content";
import {
  Button,
  Col,
  Collapse,
  Empty,
  Modal,
  Row,
  Tooltip,
  Typography
} from "antd";
import React, { useRef } from "react";
import { KEY, lang, MODE_SCREEN } from "../../constants/common.const";
import { MSG_CATCH, showMessage } from "../../constants/utils";

import {
  DeleteOutlined,
  ToTopOutlined
} from "@ant-design/icons";
import { FolderAdd } from "iconsax-react";
import { workReportNewEquipmentApi } from "../../api/backend/reportNewEquipment";

const { Panel } = Collapse;
const { Text } = Typography;
function FileAttachment({ item, index }) {
  const name = item.fileName.split(".");
  const fileType = name.pop();
  return (
    <div>
      {/* {getIconByFileType(item.attachmentUrl)} */}
     <Tooltip title={item.fileName}>
     <a
        href={item.attachmentUrl}
        title={item.attachmentUrl}
        style={{ display: "flex" }}
        target="_blank"
      >
        <p className="text-1line mb0">{name}</p>
        <span>.{fileType}</span>
      </a>
     </Tooltip>
    </div>
  );
}
const ReportMachineAttach = ({
  mode = MODE_SCREEN.VIEW,
  listAttachMachine = [],
  setListAttachMachine,
}) => {
  const fileMachineRef = useRef(null);

  // const isCustomer = roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER";
  const uploadFile = async (file, type) => {
    const formData = new FormData();
    const body = {
      attachmentUrl: file.name,
      type: type,
    };
    formData.append("data", JSON.stringify(body));
    formData.append("file", file);

    try {
      const res = await workReportNewEquipmentApi.uploadFileAttach(formData);
      const newListAttachMachine = [...listAttachMachine];
      if (type == 1) {
        newListAttachMachine.push({
          fileName:file.name,
          attachmentUrl:res.data.url
        });
        setListAttachMachine([...newListAttachMachine]);
      }

      return res.data;
    } catch (err) {
      showMessage(
        KEY.ERROR,
        (err.response && err.response.data.msg) || MSG_CATCH()
      );
    }
  };

  const handleChangeAttachMachine = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const exceedAmountFile =
      listAttachMachine.length >= 30;
    const exceedSizeFile = file.size > 100 * 1024 * 1024;
    const contentPopup = exceedAmountFile
      ? "ファイル数は 30 を超えないようにしてください"
      : "ファイルサイズは 100MB を超えないようにしてください";
    if (exceedAmountFile || exceedSizeFile) {
      e.preventDefault();
      Modal.destroyAll();
      Modal.confirm({
        centered: true,
        title: "確認",
        content: contentPopup,
        okText: lang.OK,
        cancelText: lang.CANCEL,
      });
      return;
    }

    uploadFile(file, 1);
    fileMachineRef.current.value = null;
  };
  const handleDeleteFile = (item) => {
    const newListAttachMachine = [...listAttachMachine];
    setListAttachMachine(
      newListAttachMachine.filter((x) => x.attachmentUrl != item.attachmentUrl)
    );
  };
  return (
    <BoxContent style={{ padding: "8px", margin: "8px" }}>
      <Collapse defaultActiveKey={["1"]} expandIconPosition="right">
        <Panel
          header={
            <>
              <FolderAdd variant="Bold" className="first-icon" />
              <span className="bold">{lang.ATTACH_FILE}</span>
            </>
          }
          key="1"
        >
          {listAttachMachine.length === 0 && mode === MODE_SCREEN.VIEW && (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="w100" />
          )}
          <input
            type="file"
            className="d-none"
            hidden={true}
            ref={fileMachineRef}
            onChange={handleChangeAttachMachine}
          />
          <Row className="">
            {mode !== MODE_SCREEN.VIEW && (
              <Col span={24}>
                <Button
                  disabled={listAttachMachine.length >= 30}
                  type="link"
                  onClick={(e) => fileMachineRef.current.click()}
                  className="buttonPC button--outline --todo-- wAuto"
                  style={{
                    backgroundColor: "#f7f9fc",
                    marginBottom: 10,
                    borderColor: "lightgray",
                  }}
                >
                  <ToTopOutlined />
                  {lang.ATTACH_FILE}
                </Button>
              </Col>
            )}
            <Col span={24} style={{ overflow: "auto" ,maxHeight:350,paddingRight:5}}>
              {listAttachMachine.length > 0 &&
                listAttachMachine.map((item, index) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "8px",
                        width: "100%",
                        marginBottom: "8px",
                      }}
                      key={index}
                    >
                      <div
                        style={{
                          width:mode === MODE_SCREEN.VIEW ? "100%" : "70%"
                        }}
                        span={21}
                      >
                        <FileAttachment item={item} index={index} />
                      </div>

                      {mode !== MODE_SCREEN.VIEW && (
                       
                        
                        <DeleteOutlined style={{
                          color:"red",
                        }}   onClick={() => handleDeleteFile(item)} />
                        
                      )}
                    </div>
                  );
                })}
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </BoxContent>
  );
};

export default ReportMachineAttach;
